
import { toast } from "react-toastify";
import { api } from "../../utils/api";

export const onSubmitEditLand = async (data, reset, setLoading, setError, setVisible) => {
  const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );
    console.log(data)
    console.log(data.id)

  try {
    // setLoading(true);
    console.log(data)
    console.log(data.id)
    const response = await api.put(`lands/${data.id}`, data);
    console.log(response)
    //Ação final
    reset({});
    toast.update(notification, {
      render: "Dados atualizados com sucesso!",
      autoClose: 1000,
      theme: "colored",
      type: "success",
      isLoading: false,
    });
  } catch (e) {
      toast.update(notification, {
        render: "Hm..Algo não ocorreu bem, verifique sua internet.",
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    setError(e.response.data.error);
    reset({});
  } finally {
    // setLoading(false);
    setVisible(false);
  }
};